import React from 'react';
import RepublicDay2023 from 'views/RepublicDay2023'

const SchoolProgrampage = () => {
  return <RepublicDay2023 />;
};

export default SchoolProgrampage;